import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getRatingClasses } from "../util/ratings";

const useRatingDescription = (ratingValue) => {
  const { ratings } = useSelector((state) => state.ratings);
  return ratings?.find((r) => r.value === ratingValue)?.description;
};

export const RestaurantListItemCard = ({ restaurantListItem }) => {
  const navigate = useNavigate();
  const description = useRatingDescription(restaurantListItem?.rating);
  const handleClick = () =>
    navigate(
      `/restaurants/${restaurantListItem?.listSid}/${restaurantListItem?.sid}`
    );

  return (
    <li
      onClick={handleClick}
      className="card p-4 cursor-pointer hover:border-teal-600"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="font-medium text-stone-800 truncate">
            {restaurantListItem?.restaurant?.name}
          </div>
          <div className="text-sm text-stone-500">
            {restaurantListItem?.dateAttended}
          </div>
        </div>
        {description && (
          <span
            className={`badge shrink-0 ${getRatingClasses({ description })}`}
          >
            {description}
          </span>
        )}
      </div>
    </li>
  );
};

const RestaurantListItemRow = ({ restaurantListItem }) => {
  const navigate = useNavigate();
  const description = useRatingDescription(restaurantListItem?.rating);

  const handleRowClick = () => {
    navigate(
      `/restaurants/${restaurantListItem?.listSid}/${restaurantListItem?.sid}`
    );
  };

  return (
    <tr onClick={handleRowClick} className="cursor-pointer hover:bg-stone-100">
      <td className="px-3 py-2">{restaurantListItem?.restaurant?.name}</td>
      <td className="px-3 py-2">{restaurantListItem?.dateAttended}</td>
      <td className="px-3 py-2">
        {description && (
          <span className={`badge ${getRatingClasses({ description })}`}>
            {description}
          </span>
        )}
      </td>
    </tr>
  );
};

export default RestaurantListItemRow;
